import React, { Component } from 'react';
import { action, computed } from 'mobx';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import Button from 'material-ui/Button';
import Tooltip from 'material-ui/Tooltip';
import { FormatAlignMiddle } from 'mdi-material-ui';

import withAppStore from 'decorators/withAppStore';

import styles from 'styles/components/CollapseAll';

import { ROOT_ID } from 'components/App';

@withStyles(styles)
@withAppStore
@observer
export default class CollapseAll extends Component {

  @computed get store() {
    return this.appStore.treeStore;
  }

  @computed get isVisible() {
    return this.store.nodes.filter(node => node.isExpanded).length > 0;
  }

  render() {
    const { classes } = this.props;

    return (
      this.isVisible &&
        <div className={ classes.root }>
          <Tooltip title='Свернуть все' placement='left' className={ classes.tooltip } >
            <Button disableFocusRipple variant='fab' mini onClick={ this.handleCollapseClick }>
              <FormatAlignMiddle />
            </Button>
          </Tooltip>
        </div>
    );
  }

  @action.bound
  handleCollapseClick() {
    document.getElementById(ROOT_ID).scrollTop = 0;
    this.store.nodes.filter(node => node.isExpanded).forEach(node => {
      node.isExpanded = false;
    });
    this.appStore.updateExpandedNodes();
  }

}



// WEBPACK FOOTER //
// ./src/components/CollapseAll.js